import styled, {ThemeProps} from 'styled-components';
import {Assign} from 'utility-types';

import {Theme} from '../../../../../theme/types';

export const SearchLabel = styled.label`
  opacity: 0;
  /* visibility: 'hidden'; */
  display: none;
`;

export const SearchInput = styled.input(
  (props: ThemeProps<Theme>) => `
  display: block;
  width: 100%;
  border:none;
  height: 3.5rem;
  background: ${props.theme.colors.goBrandBlue.light};
  &:focus {
    box-shadow: none;
    outline: none;
  }
  &::-webkit-input-placeholder{
    color: ${props.theme.colors.downriver.dark};
    font-weight:400;
  }
`,
);

export const AutocompleteWrapper = styled.div(
  (props: ThemeProps<Theme>) => `
  position: relative;
  width: 55%;
  @media (min-width: 768px) and (max-width: 1024px) {
    width: 100%;
    margin-bottom:${props.theme.spacing.small} ;
  } 
`,
);

export const InputWrapper = styled.div(
  props => `
  display: flex;
  padding: 0 ${props.theme.spacing.base};
  border-radius: ${props.theme.misc.borderRadius.xlarge};
  align-items: center;
  border-radius: ${props.theme.misc.borderRadius.xlarge};
  border: .1rem solid ${props.theme.colors.goBrandBlue.light};
  background: ${props.theme.colors.goBrandBlue.light};
`,
);

export const Menu = styled.ul(
  (props: Assign<ThemeProps<Theme>, {shouldOpenMenu: boolean}>) => `
  z-index: ${props.theme.misc.zIndex.base};
  position: absolute;
  // top: 4.8rem;
  list-style-type: none;
  background: ${props.theme.colors.goWhite.base};
  border-radius: 4px;
  box-shadow: 0 2px 14px 0 rgba(0, 0, 0, 0.16);
  transform: translateY(4px);
  min-width: 350px;
  max-height: 50vh;
  overflow-y: auto;
  ${SearchListItem} :first-of-type {
    border-top: none;
  }

  ::-webkit-scrollbar {
    -webkit-appearance: none;
    width: 7px;
  }

  ::-webkit-scrollbar-thumb {
    border-radius: 4px;
    background-color: ${props.theme.colors.downriver.medium};
    box-shadow: 0 0 1px ${props.theme.colors.downriver.light};
  }
`,
);

export const SearchListItem = styled.li((props: Assign<ThemeProps<Theme>, {noBorder: boolean}>) => {
  ``;
  const borderBottom = props.noBorder ? 'none' : `1px solid ${props.theme.colors.downriver.light}`;

  return `
  border-bottom: ${borderBottom};
  background: ${
    // @ts-ignore
    props.isActive ? props.theme.colors.downriver.light : props.theme.colors.goWhite.base
  };
  min-height: 48px;

  display: flex;
  align-items: center;
  cursor: pointer;
`;
});

export const SearchListItemText = styled.div(
  (props: ThemeProps<Theme>) => `
  flex: 3;
  padding: ${props.theme.spacing.small} 0;
`,
);

export const MidListItemSegregationLabel = styled.h3(
  (props: ThemeProps<Theme>) => `
  min-height: 46px;
  display: flex;
  align-items: center;
  padding-left: ${props.theme.spacing.large};
  font-weight: bold;
  font-size: ${props.theme.font.custom(14)};
  background: ${props.theme.colors.goBrandBlue.light};
`,
);

export const ErrorMessage = styled.div(
  (props: ThemeProps<Theme>) => `
  padding: ${props.theme.spacing.small};
  color: ${props.theme.colors.goRed.base};
`,
);

export const IconWrapperDiv = styled.div(
  (props: ThemeProps<Theme>) => `
  height: ${props.theme.spacing.custom(15)};
  width: ${props.theme.spacing.custom(15)};
  margin: 0 ${props.theme.spacing.base} 0 ${props.theme.spacing.large};
`,
);

export const RatingWrapper = styled.div(
  (props: ThemeProps<Theme>) => `
  flex: 1
`,
);

export const StaticLocationItemWrapper = styled.div`
  display: flex;
  width: 24rem;
`;

export const StaticLocationName = styled.span(
  props => `
  // padding: 0 0 0 ${props.theme.spacing.small};
`,
);

export const StaticLocationCount = styled.span(
  props => `
  margin-left: auto;
  color:${props.theme.colors.downriver.medium};
  position:absolute;
  right:2rem;
`,
);

export const StaticLocationsCheckboxesWrapper = styled.div(
  props => `
  // padding: '0px ${props.theme.spacing.large} 0px ${props.theme.spacing.base}';
`,
);

export const ScrollToTopWhenNoInputHiddenElement = styled.div`
  position: relative;
  visibility: hidden;
  opacity: 0;
`;
